import { useContext } from "react";
import NodeContext from "../../utils/NodeContext";
import SidebarToggle from "./SidebarToggle";
import SidebarFocus from "./SidebarFocus";
import SidebarLocation from "./SidebarLocation";
import SidebarResearcher from "./SidebarResearcher";

export default function Sidebar({ setSelectedNode, isOpen, setIsOpen }) {
	const { primaryNode } = useContext(NodeContext);
	console.log(isOpen);

	const background = {
		researcher: "bg-black",
		focus: "bg-brn-blue",
		location: "bg-brn-red",
	};

	const sidebarClasses = [
		"sidebar",
		"absolute",
		"top-40",
		"top-adjust",
		"bottom-0",
		isOpen ? "right-0" : "left-full",
		"w-3/12",
		"z-40",
		"text-white",
		"overflow-y-auto",
		isOpen ? "-ml-0" : "-ml-12",
		primaryNode ? "block" : "hidden",
		primaryNode ? background[primaryNode.type] : "bg-black",
	];

	return (
		<div className={sidebarClasses.join(" ")}>
			<SidebarToggle isOpen={isOpen} setIsOpen={setIsOpen} />
			{primaryNode && primaryNode.type === "researcher" ? (
				<SidebarResearcher isOpen={isOpen} setSelectedNode={setSelectedNode} />
			) : null}
			{primaryNode && primaryNode.type === "focus" ? (
				<SidebarFocus isOpen={isOpen} setSelectedNode={setSelectedNode} />
			) : null}
			{primaryNode && primaryNode.type === "location" ? (
				<SidebarLocation isOpen={isOpen} />
			) : null}
		</div>
	);
}
